import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

enum Variants {
  DEFAULT = 'default',
  Success = 'success',
  Danger = 'danger',
}

type BadgeProps = PropsWithChildren<{
  className?: string;
  variant?: `${Variants}`;
}>;

const variantStyles: Record<Variants, string> = {
  [Variants.DEFAULT]:
    'bg-surface-container-high border-outline-variant text-on-surface',
  [Variants.Success]:
    'bg-emphasis-container border-on-emphasis-container text-on-emphasis-container',
  // not used anywhere
  [Variants.Danger]: 'bg-critical border-critical text-on-critical',
};

export default function Badge({
  children,
  className,
  variant = 'default',
}: BadgeProps) {
  return (
    <span
      className={twMerge(
        'inline-flex max-w-max items-center gap-x-1 rounded-full border px-2 py-[0.15rem] body-sm whitespace-nowrap',
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
